import { render } from "./mobile-item.vue?vue&type=template&id=a485fec2&scoped=true&ts=true"
import script from "./mobile-item.vue?vue&type=script&lang=ts"
export * from "./mobile-item.vue?vue&type=script&lang=ts"

import "./mobile-item.vue?vue&type=style&index=0&id=a485fec2&lang=scss&scoped=true"

import exportComponent from "D:\\project\\anet\\libo\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a485fec2"]])

export default __exports__